export enum PolicyInformationEnum {
  PolicyDateInformation = 'Znaleźliśmy polisę na ten samochód, która kończy się ',
  PolicyDateInformation2 = 'Upewnij się jaka jest prawidłowa data startu polisy.',
}
